import React from "react";
import withContext from "../../common/withContext";
import {WrapperSegment} from "shared-one-ux-components";
import ProjectContext from "../projectContext";
import { useHistory, useParams } from "react-router-dom";
import { withConfig } from '../../../utilities/appConfig';

function Contextualize({
  loading,
  projectDetail,
  endUserApiTabActive,
  setEndUserApiTabActive,
  filteredApis,
  hasFilteredApis,
  events,
  title = "Development APIs",
  projectType,
  webhookUIBaseUrl,
  webhookAppShellBaseUrl,
  selectEventsTab,
  config
}) {
  const history = useHistory();
  const { enduser } = useParams();

  return (
    <div>
      <WrapperSegment
        loading={loading}
        history={history}
        projectType={projectType}
        projectDetail={projectDetail}
        endUserApiTabActive={endUserApiTabActive}
        setEndUserApiTabActive={setEndUserApiTabActive}
        events={events}
        filteredApis={filteredApis}
        hasFilteredApis={hasFilteredApis}
        title={title}
        endUser={enduser}
        project_use_case_host={`${import.meta.env.VITE_ROOT_PATH}`}
        webhookUIBaseUrl={webhookUIBaseUrl}
        webhookAppShellBaseUrl={webhookAppShellBaseUrl}
        selectEventsTab={selectEventsTab}
        webhookFeatureFlag={config?.['webhookfeatureflag']?.enabled}
      />
    </div>
  );
}

export default withConfig(withContext(Contextualize, ProjectContext));
